<template>
  <v-row>
    <v-btn
      color="#f00"
      text
      small
      @click.stop="openRequest()"
    >
      <v-icon
        small
      >
        mdi-youtube mdi-flip-h
      </v-icon>
      ポジショニングマップ作成Demo
    </v-btn>

    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">簡単にポジショニングマップを作ることができます</v-card-title>

        <v-card-text>
          データは自動でブラウザに保存されます。<br>
          バックアップ（<v-icon color="primary">mdi-download</v-icon>）、インポート（<v-icon color="primary">mdi-database-import</v-icon>）もご利用ください。
        </v-card-text>

        <div class="mx-auto px-4">
          <iframe width="100%" height="400" src="https://www.youtube.com/embed/QKIWukeUyH4?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    openRequest () {
      // イベントカテゴリ, イベントアクション, イベントラベル
      this.$ga.event('header', 'dialog', 'demo')

      this.dialog = true
    }
  }
}
</script>
